import { HTTP } from "../../../libs/HTTP";

class MediaApi {
    uriPrefix = "/api/media";

    getFileBlobByUrl (url:string) {
        return HTTP.get(url, {responseType: 'blob'})
            .then(response => response.data);
    }

    uploadFile = (url: string, file: Blob) => {
        const formData = new FormData();
        formData.append(`file`, file);
        
        return HTTP.post( url,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        ).then(response => {
            console.log('SUCCESS!!');
            return response.data
        })
        .catch(function(){
            console.log('FAILURE!!');
        });
    }
}

const mediaApi = new MediaApi();
export default mediaApi;
